import styled from "styled-components";
import { BgColor } from "../../App";
import media from "../../helpers/media"

const Container = styled(BgColor)`
display:flex;
width:100vw;
background-color: #eae8e7;
color: black;
font-family: Inconsolata, Arial, Helvetica, sans-serif;
justify-content:space-between;
flex-direction: column;
@media ${media.tablet} {
    perspective: 1000px;
    flex-direction: row;
    height:auto;
    height:100vh;

}
`;

const Description = styled.div`
display:flex;
flex-direction:column;
justify-content:space-between;
height: 100vh;
@media ${media.tablet} {
    flex:2;
    height:auto;
}

`;

const ResumePlaceholder = styled.div`
@media ${media.tablet} {
    flex:3;
}

display:flex;
justify-content:center;
align-items:center;
`;

const MenuBar = styled.div`
display:flex;
margin:30px;
align-items:center;
font-weight:bold;
color:black;
&>div{
    font-size:22px ;
    margin-left:8px;
    line-height:14px;
}
`;

const TagLine = styled.div`
font-size:26px;
font-weight:bold;
margin-left:30px;
`;

const SubTag = styled.div`
font-size:14px;
font-style:italic;
margin-top:5px;
`;

const Button = styled.button`
margin:20px 0;
font-size:15px;
&::after{
    background:black;
}
&::active{
    background:black;
}
`;

const Social = styled.div`
display:flex;
margin:0 0 30px 30px;

&>*{
    margin-right:20px;
}
`;

const A = styled.a`
text-decoration: none;
`;

const CvImg = styled.img`
margin:20px 10px;
max-width:90%;
height:520px;
@media ${media.tablet} {
    max-width:320px;
    height:85%;
    transform-style: preserve-3d;
    margin:0;
}

@media ${media.laptopL} {
    max-width:600px;
    height:80%;
    transform-style: preserve-3d;
    margin:0;
}
`;

const Img = styled.img`
height:30px;
transition: all .2s ease-in-out;
&:hover{
    transform: scale(1.4);
    background-color:inherit
};
&:active &::after &::before &:focus{
    background-color:red
};

`;

const ImageHolder = styled.div`
width: 100%;
height:100%;
display: flex;
justify-content: center;
@media ${media.tablet} {
height:80%;
max-width:300px;
position: relative;
background-position: top center;
transform-style: preserve-3d;

&:after {
    content: '';
    position: absolute;
    width: 100%;
    height: 8px;
    border-radius: 50%;
    left: 0;
    bottom: 33px;
    box-shadow: 0 30px 20px rgba(0, 0, 0, .3);
}
}
`;

const LinkStyled = styled(A)`
text-decoration: none;
display: inline-block; 
color: inherit;
cursor:pointer;
padding-right:10px;
margin-left:10px;
border-right:1px solid black; 
transition: all .2s ease-in-out;
&:last-child {
    border-right:none; 
}
&:active &:focus{
    border-radius:0px !important;
    background-color:inherit !important;
}
&:hover{
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    background-color:inherit
};
@keyframes shake {
  10%, 90% {
    transform: translate3d(-1px, 0, 0);
  }

  20%, 80% {
    transform: translate3d(2px, 0, 0);
  }

  30%, 50%, 70% {
    transform: translate3d(-4px, 0, 0);
  }

  40%, 60% {
    transform: translate3d(4px, 0, 0);
  }
}
`;

const LinksWrapper = styled.div`
position:inherit;
height:30px;
bottom:0;
right:20px;
@media ${media.tablet} {
    position:absolute;
}
`;

const SiteTitle = styled.h1`
    font-size: 20px;
    margin-bottom: 12px;
`;

export { Container, Description, ResumePlaceholder, MenuBar, TagLine, SubTag, Button, Social, A, CvImg, Img, ImageHolder, LinkStyled, LinksWrapper, SiteTitle }